module.exports = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError((name ? name + ': i' : 'I') + 'ncorrect invocation!');
  } return it;
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/an-instance.js
// module id = 52
// module chunks = 0